//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import { namespace } from 'nuxt-property-decorator';

const MyAcuvue = namespace("myacuvue");

export default {

  props: {
    category: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },

  computed: {
    balance: function () {
      return this.$store.state?.myacuvue?.profile?.myacuvueUser?.points_my_acuvue_points || 0
    },

    show: function() {
      if (this.category?.name !== 'Контактные линзы') {
        return false
      }

      // Если стоит запрет на использование MyAcuvue
      if (!Boolean(process.env.myAcuvueIncluded || false)) {
        return false
      }

      // Получение пользователя из хранилища
      const profile = this.$store.state?.myacuvue?.profile || {};

      return Object.keys(profile).length > 0
    }
  }

};
